<div class="overflow-scroll">
    <p-table #dt styleClass="p-datatable-responsive-demo" [value]="subscriptionItem.orders"
        [globalFilterFields]="app.keys(subscriptionItem.orders)">
        <ng-template pTemplate="caption">
            <div class="table-header d-flex flex-wrap">
                <span class="p-float-label p-input-icon-left m-2 flex-grow-1">
                    <i class="pi pi-search "></i>
                    <input pInputText class="w-100" id="globalSearch" name="globalSearch" style="width: 100%" type="text"
                        (input)="dt.filterGlobal($event.target.value, 'contains')" />
                    <label for="globalSearch">Search...</label>
                </span>
            </div>
    
        </ng-template>
        <ng-template pTemplate="header" #header>
            <tr>
                <th>Date</th>
                <th>Check #</th>
                <th>Total</th>
                <th>Status</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" #body let-rec let-idx=rowIndex>
            <tr (click)="checkRecordSelectedChange.emit(rec)">
                <td>
                    <span class="p-column-title">Date</span>
                    {{app.moment(rec.created).format('l LT')}}
                </td>
                <td>
                    <span class="p-column-title">Check #</span>
                    {{rec.checkNumber}}
                </td>
                <td class="">
                    <span class="p-column-title">Total</span>
                    {{rec.total | currency}}
                </td>
                <td>
                    <span class="p-column-title">Status</span>
                    <fa-icon *ngIf="rec.open" [icon]='["far","check"]'></fa-icon>
                    <fa-icon *ngIf="!rec.open" [icon]='["far","times"]'></fa-icon>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
